import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { API_URL } from '@frontend-site/shared/data';
import { Observable } from 'rxjs';
import { MfaMethod } from '../entities/mfa-method.enum';
import { MfaAppEnrollment, UserMfaState } from '../entities/user-mfa-state';

/**
 * Profile-side MFA management for the logged-in user (Security tab).
 * Enrollment and removal commit immediately; the *default* method is staged in the
 * profile form and saved through `UserService.changeProfile` with the rest of the profile.
 */
@Injectable({ providedIn: 'root' })
export class UserMfaService {
    constructor(private readonly http: HttpClient, @Inject(API_URL) private readonly apiUrl: string) {}

    getState(companyId?: number): Observable<UserMfaState> {
        const params = companyId != null ? new HttpParams().set('companyId', companyId) : undefined;
        return this.http.get<UserMfaState>(`${this.apiUrl}/UM/mfa/state`, { params });
    }

    startAppEnrollment(): Observable<MfaAppEnrollment> {
        return this.http.post<MfaAppEnrollment>(`${this.apiUrl}/UM/mfa/app/start`, {});
    }

    confirmAppEnrollment(enrollmentToken: string, code: string, companyId?: number): Observable<UserMfaState> {
        return this.http.post<UserMfaState>(
            `${this.apiUrl}/UM/mfa/app/confirm`, { enrollmentToken, code, companyId }
        );
    }

    removeMethod(method: MfaMethod, companyId?: number): Observable<UserMfaState> {
        return this.http.post<UserMfaState>(`${this.apiUrl}/UM/mfa/remove`, { method, companyId });
    }
}
